import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiGet } from "../../api/apiclient";
import { AI_AGENTS, PROCESSED_DOCUMENTS, PROCESSED_DOCUMENTS_DETAILS } from "../../api/endpoints";

// Async thunk for logging in
export const loadAIAgents = createAsyncThunk(
  "/api/ai_agents/",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiGet(AI_AGENTS);
      if (response?.data.status === "success") {
        return response?.data;
      } else {
        return rejectWithValue(
          response.data.message || "Unexpected error occurred."
        );
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message || "Network error occurred.");
    }
  }
);

// Async thunk for logging in
export const processedDocuments = createAsyncThunk(
  "/api/processed_documents/",
  async (slugname, { rejectWithValue }) => {
    const url =`${PROCESSED_DOCUMENTS}${slugname}/`
    try {
      const response = await apiGet(url);
   
      if (response?.data.status === "success") {
        console.log('response?.data?.documents',response?.data?.data?.documents)
        return response?.data?.data?.documents;
      } else {
        return rejectWithValue(
          response.data.message || "Unexpected error occurred."
        );
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message || "Network error occurred.");
    }
  }
);

// Async thunk for logging in
export const processedDocumentsDetailsAPI = createAsyncThunk(
  "/api/processed_documents_details/",
  async (slugname, { rejectWithValue }) => {
    const url =`${PROCESSED_DOCUMENTS_DETAILS}${slugname}/`
    try {
      const response = await apiGet(url);
   
      if (response?.data.status === "success") {
        console.log('response?.data?.documents',response?.data?.data?.documents)
        return response?.data?.data?.documents;
      } else {
        return rejectWithValue(
          response.data.message || "Unexpected error occurred."
        );
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message || "Network error occurred.");
    }
  }
);

const LoadAIAgentsSlice = createSlice({
  name: "ai_agents",
  initialState: {
    agentListLoading: false,
    agentListError: {},
    agentList: [],

    processedDocumentsList:[],
    processedDocumentsListLoading: false,
    processedDocumentsListError: {},

    processedDocumentsDetails:[],
    processedDocumentsDetailsLoading: false,
    processedDocumentsDetailsError: {},

  },
  extraReducers: (builder) => {
    builder
      .addCase(loadAIAgents.pending, (state) => {
        state.agentListLoading = true;
        state.error = null;
      })
      .addCase(loadAIAgents.fulfilled, (state, action) => {
        state.agentListLoading = false;
        state.agentList =
          Array.isArray(action.payload?.data?.agents) &&
          action.payload?.data?.agents.length > 0
            ? action.payload.data.agents
            : state.agentList;
      })
      .addCase(loadAIAgents.rejected, (state, action) => {
        state.agentListLoading = false;
        state.agentListError = action?.payload?.agentListError;
      });

      builder
      .addCase(processedDocuments.pending, (state) => {
        state.processedDocumentsListLoading = true;
        state.processedDocumentsListError = null;
      })
      .addCase(processedDocuments.fulfilled, (state, action) => {
        state.processedDocumentsListLoading = false;
        state.processedDocumentsList = action.payload
      })
      .addCase(processedDocuments.rejected, (state, action) => {
        state.processedDocumentsListLoading = false;
      });
      builder
      .addCase(processedDocumentsDetailsAPI.pending, (state) => {
        state.processedDocumentsDetailsLoading = true;
        state.processedDocumentsDetailsError = null;
      })
      .addCase(processedDocumentsDetailsAPI.fulfilled, (state, action) => {
        state.processedDocumentsDetailsLoading = false;
        state.processedDocumentsDetails = action.payload
      })
      .addCase(processedDocumentsDetailsAPI.rejected, (state, action) => {
        state.pprocessedDocumentsDetailsLoading = false;
      });
  },
});

export default LoadAIAgentsSlice.reducer;
